import axios from '@api/axiosInstance.js'

export const fetchAuthToken = async (token) => {
  const res = await axios.post(
    '/auth/token',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true
    }
  )
  return res.data
}

export const fetchAuthTokenWithCompanyCode = async (companyCode) => {
  const res = await axios.get(`/auth/login`, {
    params: { companyCode },
    withCredentials: true
  })

  return res.data
}

export const fetchServerTime = async (payload = {}) => {
  try {
    const res = await axios.post(`/system/server-time`, payload)
    return res.data
  } catch (err) {
    const rspCode = err.response?.data?.rspCode
    if (rspCode === 'A1004' || err.response?.status === 500) {
      return null
    }
    throw err
  }
}

export const fetchOrgInfo = async (payload = {}) => {
  try {
    const res = await axios.post(`/org/info`, payload)
    return res.data
  } catch (err) {
    console.log(err)
    const rspCode = err.response?.data?.rspCode
    if (rspCode === 'A1004' || err?.status === 500) {
      return null
    }
    throw err
  }
}